import React from 'react';
import { useNavigate } from 'react-router-dom';

export const CtaBar: React.FC = () => {
  const navigate = useNavigate();
  return (
    <section className="px-4 md:px-8">
      <button
        onClick={() => navigate('/form')}
        className="group mx-auto my-[10px] flex w-full max-w-[1180px] items-center justify-between gap-4 rounded-full pl-[2em] pr-[1em] py-[1em] text-left text-white transition-transform hover:scale-[1.01] sm:p-5 md:my-[25px] md:px-[50px] md:py-8"
        style={{ backgroundColor: 'var(--color-primary, #143b6b)' }}
      >
        <span className="!font-['Inter'] text-2xl sm:text-[clamp(1.625rem,44px,56px)] font-light normal-case leading-none text-white">
          Get a free quote in just minutes!
        </span>
        <svg
          className="size-9 shrink-0 text-white/70 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1 md:size-14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M7 17 17 7M8 7h9v9" />
        </svg>
      </button>
    </section>
  );
};
